import styled from 'styled-components';

import { BREAK_POINTS } from '../../../consts/styleDedupe';

export const AwardsContainer = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 24px;
  background-color: rgba(0, 0, 0, 0.16);
  color: white;
  border-radius: 8px;
  padding: 8px ${12 - 8}px 8px 12px;
  margin-top: 48px;
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: inline-block;
    border-radius: 24px;
    padding: 8px ${20 - 8}px 8px 20px;
  }
`;

export const StarContainer = styled.div`
  flex-basis: 108px;
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: inline-block;
    width: 108px;
  }
`;

export const CommentContainer = styled.div`
  text-align: left;
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: inline-block;
    text-align: center;
  }
  & > p {
    display: inline-block;
    padding: 0 8px;
    margin: 0;
  }
`;
